// Tiny in-memory store for the floating Upload Status panel.
// Status: "uploading" | "waiting" | "done" | "failed"
let items = [];
let seq = 0;
const listeners = new Set();

const emit = () => listeners.forEach((fn) => fn(items));

export const subscribeUploads = (fn) => {
  listeners.add(fn);
  fn(items);
  return () => listeners.delete(fn);
};

export const addUpload = (name, label) => {
  const id = `u${++seq}`;
  items = [...items, { id, name, label, status: "uploading", queueId: null, message: "" }];
  // Keep the list bounded on long sessions: trim the oldest finished rows.
  const finished = items.filter((it) => it.status === "done");
  if (finished.length > 50) {
    const drop = new Set(finished.slice(0, finished.length - 50).map((it) => it.id));
    items = items.filter((it) => !drop.has(it.id));
  }
  emit();
  return id;
};

export const updateUpload = (id, patch) => {
  items = items.map((it) => (it.id === id ? { ...it, ...patch } : it));
  emit();
};

export const updateByQueueId = (queueId, patch) => {
  if (queueId == null) return false;
  let hit = false;
  items = items.map((it) => {
    if (it.queueId !== queueId) return it;
    hit = true;
    return { ...it, ...patch };
  });
  if (hit) emit();
  return hit;
};

export const clearFinished = () => {
  items = items.filter((it) => it.status === "uploading" || it.status === "waiting");
  emit();
};
